
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ModalCompleteReport extends Vue {

  /* PROP */

  @Prop({default: false})
  private isShow: boolean;

  /* INITIALIZATION */

  constructor() {
    super();
  }
}
